import React from 'react'
import { withStyles } from '@material-ui/core/styles'
import { InputLabel, MenuItem, Select, FormControl } from '@material-ui/core'
import { ISortByDropdown } from './types'

const styles = () => ({
  dropdownStyle: {
    top: '111px !important',
  },
})

export const SortByDropdownComponent = ({
  filterValues,
  updateFilters,
  sortTypes,
  classes,
}: ISortByDropdown) => (
    <FormControl>
      <InputLabel shrink>Sort by</InputLabel>
      <Select
        value={filterValues.orderBy}
        onChange={({ target }) => {
          updateFilters({ ...filterValues, orderBy: target.value })
        }}
        MenuProps={{ classes: { paper: classes.dropdownStyle } }}
      >
        {sortTypes.map(({ value, label }, index) => (
          <MenuItem key={index} value={value}>
            {label}
          </MenuItem>
        ))}
      </Select>
    </FormControl>
  )

export const SortByDropdown =  withStyles(styles)(SortByDropdownComponent)
